import setAsyncState from '@functions/setAsyncState.ts';

import I from '../types.ts';

const questionHandler: I['questionHandler'] = async function (key) {
    await this.init();
    await setAsyncState.call(this, {
        currentQuestion: this.state.currentQuestion === key ? null : key,
    });
};

export default questionHandler;
